module.exports = __webpack_public_path__ + "static/media/IconActivityHNY.3f286a40.svg";